let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_USER_ROLE":"Create User Role",
    "LBL_VIEW_USER_ROLE":"View User Role",
    "LBL_ADD_USER_GROUP":"Add User Group",
    "LBL_USER_GROUP_NAME":"User Group Name",
    "LBL_ACCESS_PERMISSION":"Access Permission",
    "LBL_LIST_PERMISSION":"List Permission",
    "LBL_VIEW_PERMISSION":"View Permission",
    "LBL_ADD_PERMISSION":"Add Permission",
    "LBL_EDIT_PERMISSION":"Edit Permission",
    "LBL_DELETE_PERMISSION":"Delete Permission",
    "LBL_EXPORT_PERMISSION":"Export Permission",
    "LBL_STATUS":"Status",
    "LBL_NAME":"Name",
    "LBL_FIRST_NAME":"First Name",
    "LBL_ROLE_NAME":"Role Name",
    "LBL_CREATED_DATE":"Date Created",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_ACTION_EDIT":"Edit",
    "LBL_ACTION_DELETE":"Delete",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_AUDIT_LOG":"Audit Log",
    
    
}

export default language;